export const formatIndianValue = (value, useFormat = true) => {
    if (value == null || isNaN(Number(value))) return "0.00";

    const n = Number(value);

    // ---- If formatting OFF → Still apply Indian comma style ----
    if (!useFormat) {
        return formatWithIndianCommas(n);
    }

    // ---- Existing formatting logic ----
    const abs = Math.abs(n);

    if (abs >= 1e7) return (n / 1e7).toFixed(2) + " Cr";
    if (abs >= 1e5) return (n / 1e5).toFixed(2) + " Lk";
    if (abs >= 1e3) return (n / 1e3).toFixed(2) + " Th";

    return n.toFixed(2);
};


// Utility function to place commas in Crore/Lakh format
const formatWithIndianCommas = (num) => {
    const isNegative = num < 0;
    const [intPart, decimalPart = "00"] = Math.abs(num).toFixed(2).split(".");

    let lastThree = intPart.slice(-3);
    let otherNumbers = intPart.slice(0, intPart.length - 3);

    if (otherNumbers !== "") {
        lastThree = "," + lastThree;
        otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    }

    return (isNegative ? "-" : "") + otherNumbers + lastThree + "." + decimalPart;
};
